export function YouTubeBorder(props) {
  return (
    <svg
      width="374"
      height="14"
      preserveAspectRatio="none"
      viewBox="0 0 374 14"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-0.5 14H-0.335284H374.5V3L354.77 4.89439L337.699 3.28634L314.305 7.79412L290.815 4.89439L276.711 7.79412L263.792 3.28677L236.187 4.89439L208.584 7.00224L185.221 1.70454C185.221 1.70454 173.971 5.58296 169 5.58296C164.029 5.58296 161.5 1.70454 157.629 1.70454C153.759 1.70454 132.046 8.52116 132.046 8.52116L107.874 7.00224H85.215L41.4195 0L15.3503 4.89439L-0.5 3V14Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  )
}
